import { createApp } from 'vue'
import App from './App.vue'
import routes from './routes'
import store from './store'
import { CHANGE_URL } from './store/type.actions'
import axios from "axios";

const isViewLink = window.location.pathname.startsWith('/view-link/');

if (isViewLink && window.location.search) {
  window.history.replaceState(null, '', window.location.pathname);
}

const app = createApp(App)

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

let token = urlParams.get('token');
let content = urlParams.get('content');

if (token === 'null') {
  token = null;
}
if (content === 'null') {
  content = null;
}

if (content) {
  try {
    content = atob(content)
    localStorage.setItem('qrmanager/userdata', content)
    content = content.replace('url=', 'lru=')
    content = btoa(content)
  } catch(e) {
    content = '';
  }
}

if (token)
  localStorage.setItem("query", JSON.stringify({ token: token }))
else {
  localStorage.setItem('query', null);
}

routes.beforeEach((to, from, next) => {
  if (token || content) {
    const query = { ...to.query };
    if (token) {
      query.token = token;
    }
    if (content) {
      query.content = content;
    }
    if (to.query.token !== query.token || to.query.content !== query.content) {
      next({ path: to.path, query, hash: to.hash, replace: true });
      return;
    }
  }
  Promise.all([store.dispatch(CHANGE_URL, to)]).then(next())
});

axios.defaults.baseURL = '/';

const mountApp = async () => {
  app.use(store);
  app.use(routes);
  app.mount('#app');
};

if (isViewLink) {
  await mountApp();
} else {
  try {
    await axios.get('api/qrcodes/login', {
      params: { token: token }
    });
    await mountApp();
  } catch (e) {
    document.getElementById('app').innerHTML = "Please login first."
  }
}
